module.exports = __webpack_public_path__ + "img/banner.b6770390.png";